var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { FeatureFlag } from "healthex-common/features.dtos";
import { computed, observable } from "mobx";
import { determineOrgId, PatientConsentViewModel } from "./PatientConsentViewModel";
import { LoginSource } from "healthex-common/heap.dtos";
import { Disposer } from "../Infra/Disposer";
import { PatientConsentSessionState } from "./PatientConsentSession";
import { ClearAuthState } from "../Infra/Persistence";
export class PatientConsentClearUpgradeViewModel extends PatientConsentViewModel {
    constructor(container) {
        super(container);
        this.disposer = new Disposer();
        this.isSandboxLogin = false;
        this.hasClearError = false;
        this.featureManager = container.featureManager;
        this.clearAuthManager = container.clearAuthManager;
        this.loginUIManager = container.loginUIManager;
        this.persistence = container.persistence;
        this.isSandboxLogin = this.persistence.isSandboxLogin();
    }
    run() {
        this.disposer.reaction(() => this.patientConsentUIManager.session.patientConsentSessionState, (state) => {
            if (state === PatientConsentSessionState.RESTORING_COMPLETED) {
                this.handleClearLoginResultIfNeeded();
            }
        }, { fireImmediately: true, name: "PatientConsentClearUpgradeViewModel_clearAuthManagerState" });
    }
    stop() {
        this.disposer.dispose();
    }
    get viewToDisplay() {
        var _a;
        if (this.hasClearError)
            return "CLEAR_ERROR";
        if (this.authManager.hasPatientSwitchedAccounts === true)
            return "ACCOUNT_SWITCHED";
        const isIAL2Expired = (_a = this.patientConsentUIManager.getIAL2Info()) === null || _a === void 0 ? void 0 : _a.ial2Expired;
        if (isIAL2Expired === true)
            return "CLEAR_EXPIRED";
        if (isIAL2Expired === null)
            return "LOADING";
        return this.featureManager.isFeatureEnabled(FeatureFlag.CLEAR_FORWARD_UPGRADE) ? "CLEAR_FORWARD" : "FASTEN_FORWARD";
    }
    get flipLongPressLoginButton() {
        return this.isSandboxLogin;
    }
    get sharedWithName() {
        if (this.isIAS) {
            return null;
        }
        else if (this.isAIFlow) {
            return this.aiToolName;
        }
        else {
            return this.organizationName;
        }
    }
    get patientEmail() {
        return this.authManager.patientEmail;
    }
    get isLoggingIn() {
        return this.clearAuthManager.state === ClearAuthState.IN_PROGRESS;
    }
    get isClearLoginSuccess() {
        return this.clearAuthManager.state === ClearAuthState.SUCCESS;
    }
    async verifyWithClear(isSandbox) {
        if (this.isScreenshotMode)
            return;
        this.patientConsentUIManager.setHasLoggedInDuringConsent();
        this.persistence.setSandboxLogin(isSandbox);
        await this.patientConsentUIManager.loginToClearAndSaveState(window.location.hash, isSandbox, LoginSource.CONSENT_CLEAR_UPGRADE, this.viewToDisplay === "CLEAR_ERROR", determineOrgId(this.loginUIManager, this.studyInfo));
    }
    findRecordsMyself() {
        this.goToNextPage();
    }
    continueAfterAccountSwitch() {
        const nextPageRoute = this.getNextPageRoute();
        if (nextPageRoute) {
            this.goToNextPageAndResetAuth(nextPageRoute);
        }
        this.authManager.hasPatientSwitchedAccounts = false;
    }
    handleClearLoginResultIfNeeded() {
        var _a;
        if (((_a = this.patientConsentUIManager.getIAL2Info()) === null || _a === void 0 ? void 0 : _a.ial2Authorized) === true && this.isClearLoginSuccess) {
            const nextPageRoute = this.getNextPageRoute();
            if (nextPageRoute && !this.authManager.hasPatientSwitchedAccounts) {
                this.goToNextPageAndResetAuth(nextPageRoute);
            }
        }
        else {
            this.hasClearError = true;
        }
        this.patientConsentUIManager.completeStateRestoration();
    }
    getNextPageRoute() {
        var _a, _b;
        return (_b = (_a = this.clearAuthManager.getClearAuthData()) === null || _a === void 0 ? void 0 : _a.nextPageRoute) !== null && _b !== void 0 ? _b : null;
    }
    goToNextPageAndResetAuth(nextPageRoute) {
        if (nextPageRoute) {
            this.goToPage(nextPageRoute);
            this.clearAuthManager.resetAuth();
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Boolean)
], PatientConsentClearUpgradeViewModel.prototype, "isSandboxLogin", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentClearUpgradeViewModel.prototype, "hasClearError", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentClearUpgradeViewModel.prototype, "viewToDisplay", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentClearUpgradeViewModel.prototype, "flipLongPressLoginButton", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentClearUpgradeViewModel.prototype, "sharedWithName", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentClearUpgradeViewModel.prototype, "patientEmail", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentClearUpgradeViewModel.prototype, "isLoggingIn", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentClearUpgradeViewModel.prototype, "isClearLoginSuccess", null);
